import React, { useState } from "react";
import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";
import Input from "../../../components/ui/Input";

const CallToAction = () => {
  const [email, setEmail] = useState("");
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleNewsletterSubmit = async (e) => {
    e?.preventDefault();
    setIsLoading(true);

    // Simulate API call
    setTimeout(() => {
      setIsSubscribed(true);
      setIsLoading(false);
      setEmail("");
    }, 1500);
  };

  const handleDownloadResume = () => {
    // Simulate resume download
    const link = document.createElement("a");
    link.href = "/assets/resume/sarah-johnson-resume.pdf";
    link.download = "Sarah-Johnson-Resume.pdf";
    link?.click();
  };

  const handleScrollToContact = () => {
    const contactSection = document.getElementById("contact");
    if (contactSection) {
      contactSection?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section className="py-20 bg-gradient-to-br from-primary/5 via-background to-accent/5">
      <div className="max-w-6xl mx-auto px-4">
        {/* Main CTA Section */}
        <div className="bg-card rounded-3xl p-8 md:p-12 shadow-elevation-lg mb-12">
          <div className="text-center max-w-3xl mx-auto">
            <div className="inline-flex items-center px-4 py-2 bg-primary/10 text-primary rounded-full text-sm font-medium mb-6">
              <Icon name="Rocket" size={16} className="mr-2" />
              Ready to Collaborate
            </div>

            <h2 className="text-3xl md:text-5xl font-bold text-foreground mb-6">
              一緒に素晴らしいものを
              <span className="text-primary bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent">
                {" "}
                作りましょう！
              </span>
            </h2>

            <p className="text-lg text-text-secondary mb-8 leading-relaxed">
              お客様の業務改善に役立つ FileMaker
              アプリを共に作り上げていけることを、心から楽しみにしています。課題やアイデアを伺いながらディスカッションを重ね、最適な形に磨き上げていく過程こそ大切だと考えています。どのようなニーズにも柔軟に対応し、一緒に「より良い仕組み」を形にしていきましょう。
            </p>

            {/* Primary CTAs */}
            {/* <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
              <Button
                variant="default"
                size="lg"
                onClick={handleScrollToContact}
                iconName="MessageCircle"
                iconPosition="left"
                className="hover-lift"
              >
                Start a Project
              </Button>

              <Button
                variant="outline"
                size="lg"
                onClick={handleDownloadResume}
                iconName="Download"
                iconPosition="left"
                className="hover-lift"
              >
                Download Resume
              </Button>
            </div> */}

            {/* Quick Contact Options */}
            <div className="flex flex-wrap justify-center gap-6 text-base text-text-secondary">
              <a
                href="mailto:info@cue-lock.jp"
                className="flex items-center space-x-2 hover:text-primary transition-micro"
              >
                <Icon name="Mail" size={24} />
                <span>info@cue-lock.jp</span>
              </a>

              {/* <a
                href="tel:+1234567890"
                className="flex items-center space-x-2 hover:text-primary transition-micro"
              >
                <Icon name="Phone" size={16} />
                <span>+1 (234) 567-8900</span>
              </a> */}

              {/* <a
                href="https://calendly.com/sarahjohnson"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-2 hover:text-primary transition-micro"
              >
                <Icon name="Calendar" size={16} />
                <span>Schedule a Call</span>
              </a> */}
            </div>
          </div>
        </div>

        {/* Newsletter Subscription */}
        {/* <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <h3 className="text-2xl font-semibold text-foreground mb-4">
              Stay Updated with My Journey
            </h3>
            <p className="text-text-secondary mb-6">
              Subscribe to my newsletter for the latest updates on projects, tech insights, 
              tutorials, and industry trends. No spam, just valuable content delivered monthly.
            </p>
            
            <div className="flex items-center space-x-4 text-sm text-text-secondary">
              <div className="flex items-center space-x-2">
                <Icon name="CheckCircle" size={16} className="text-success" />
                <span>Monthly updates</span>
              </div>
              <div className="flex items-center space-x-2">
                <Icon name="CheckCircle" size={16} className="text-success" />
                <span>No spam</span>
              </div>
              <div className="flex items-center space-x-2">
                <Icon name="CheckCircle" size={16} className="text-success" />
                <span>Unsubscribe anytime</span>
              </div>
            </div>
          </div>

          <div className="bg-card rounded-2xl p-6 shadow-elevation-sm">
            {!isSubscribed ? (
              <form onSubmit={handleNewsletterSubmit} className="space-y-4">
                <Input
                  type="email"
                  label="Email Address"
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => setEmail(e?.target?.value)}
                  required
                  className="mb-4"
                />
                
                <Button
                  type="submit"
                  variant="default"
                  size="lg"
                  loading={isLoading}
                  iconName="Send"
                  iconPosition="right"
                  fullWidth
                  className="hover-lift"
                >
                  Subscribe to Newsletter
                </Button>
                
                <p className="text-xs text-text-secondary text-center">
                  By subscribing, you agree to receive email updates. You can unsubscribe at any time.
                </p>
              </form>
            ) : (
              <div className="text-center py-8">
                <div className="w-16 h-16 bg-success/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Icon name="CheckCircle" size={32} className="text-success" />
                </div>
                <h4 className="text-xl font-semibold text-foreground mb-2">
                  Thanks for Subscribing!
                </h4>
                <p className="text-text-secondary">
                  You'll receive my next newsletter with updates and insights. 
                  Check your inbox for a confirmation email.
                </p>
              </div>
            )}
          </div>
        </div> */}

        {/* Services Preview */}
        {/* <div className="mt-16 grid md:grid-cols-3 gap-8">
          <div className="text-center p-6 bg-card rounded-xl shadow-elevation-sm hover:shadow-elevation-md transition-layout hover-lift">
            <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
              <Icon name="Code" size={32} className="text-primary" />
            </div>
            <h4 className="text-lg font-semibold text-foreground mb-2">
              Full-Stack Development
            </h4>
            <p className="text-text-secondary text-sm">
              End-to-end web application development with modern technologies and best practices
            </p>
          </div>

          <div className="text-center p-6 bg-card rounded-xl shadow-elevation-sm hover:shadow-elevation-md transition-layout hover-lift">
            <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
              <Icon name="Palette" size={32} className="text-primary" />
            </div>
            <h4 className="text-lg font-semibold text-foreground mb-2">
              UI/UX Design
            </h4>
            <p className="text-text-secondary text-sm">
              User-centered design solutions that combine aesthetics with functionality
            </p>
          </div>

          <div className="text-center p-6 bg-card rounded-xl shadow-elevation-sm hover:shadow-elevation-md transition-layout hover-lift">
            <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
              <Icon name="Users" size={32} className="text-primary" />
            </div>
            <h4 className="text-lg font-semibold text-foreground mb-2">
              Technical Consulting
            </h4>
            <p className="text-text-secondary text-sm">
              Strategic guidance on technology choices, architecture, and development processes
            </p>
          </div>
        </div> */}
      </div>
    </section>
  );
};

export default CallToAction;
